import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage, intlMessageShape } from 'sb-react-intl'

import s from './Title.scss'


// TODO replace this component with standard Title component - one Title component for all places

const UpgradeSubscriptionFlowTitle = ({ className, message }) => (
  <FormattedMessage
    className={cx(className, s.title, 'upgradeSubscriptionFlowTitle')}
    tag="div"
    {...message}
  />
)

UpgradeSubscriptionFlowTitle.propTypes = {
  className: PropTypes.string,
  message: PropTypes.shape(intlMessageShape).isRequired,
}


export default UpgradeSubscriptionFlowTitle
